export const MEMBER_ROLE = 30
export const ADMIN_ROLE = 40

export const roles = {
  [MEMBER_ROLE]: 'member',
  [ADMIN_ROLE]: 'admin',
}

export const getRoleLabel = code => roles[code]
